import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        // fontFamily: "'Poppins Medium', 'Poppins', sans-serif",
        fontFamily: "'Poppins'",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '13px',
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    fontSize: '12px',
                    fontWeight: 500,
                    height: '40px',
                    border: '1px solid lightgrey',
                    borderRadius: '6px',
                    '&:before, &:after': {
                        display: 'none',
                    },
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                option: {
                    fontSize: '13px',
                    // padding:0
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '12px',
                    fontWeight: 400,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    // boxShadow: "0px 2px 5px rgba(0,0,0,0.15)",
                     boxShadow: "0px 4px 5px rgba(0,0,0,0.15), 0px -1px 8px rgba(0,0,0,0.1)", 
                    transition: "box-shadow 0.3s ease-in-out",
                },
            },
            defaultProps: {
                // elevation: 2, 
            },
        },
        MuiSelect: {
  styleOverrides: {
    select: {
      fontSize: "13px",
      fontFamily: "Poppins, sans-serif",
    },
  },
},

    },
});

export default theme;
